import { render, staticRenderFns } from "./OverdueNoticeNextStep.vue?vue&type=template&id=4154cc5d&scoped=true&"
import script from "./OverdueNoticeNextStep.vue?vue&type=script&lang=ts&"
export * from "./OverdueNoticeNextStep.vue?vue&type=script&lang=ts&"
import style0 from "./OverdueNoticeNextStep.vue?vue&type=style&index=0&id=4154cc5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154cc5d",
  null
  
)

export default component.exports